// Pages whose address has changed.
//
// The OLD url is kept working elsewhere: vercel.json 301s it at the edge, and
// gatsby-node.js registers the same hop with Gatsby's client router. This file
// is the other half of a move — it stops the site linking to the old url at
// all, so neither a visitor nor a crawler meets a redirect on an internal link.
//
// It is needed only because the links involved are authored in Contentful (the
// main nav's "Pricing" item, and an <a> in one blog post body), and a CMS-only
// edit does not reach production by itself — see SERVICE_AREAS_ITEM in
// Navbar.js. Both helpers leave an unlisted url untouched, so once an entry is
// corrected in Contentful its row here is dead and can be deleted.
//
// Keys are compared lower-cased and without a trailing slash. A Map, not an
// object literal: a relative href that happened to read `constructor` would
// find Object.prototype's and come back truthy.
const MOVED_PATHS = new Map([["/calculator", "/roofing-cost-calculator-michigan/"]]);

// Body links to this site are sometimes written absolute. The origin is carried
// through as typed; only the path is swapped.
const SITE_ORIGIN = /^https?:\/\/(?:www\.)?roachhomeimprovement\.com(?=[/?#]|$)/i;

export const resolveMovedUrl = (url) => {
  if (typeof url !== "string") return url;
  const trimmed = url.trim();
  const origin = (SITE_ORIGIN.exec(trimmed) || [""])[0];
  const [, path, suffix] = /^([^?#]*)([\s\S]*)$/.exec(trimmed.slice(origin.length));
  const moved = MOVED_PATHS.get(path.replace(/\/+$/, "").toLowerCase());
  return moved ? `${origin}${moved}${suffix}` : url;
};

// Rewrites the href of every link in a block of CMS html. Markup that carries no
// moved url comes back character-for-character identical.
export const rewriteMovedLinks = (html) =>
  typeof html === "string"
    ? html.replace(/(\shref\s*=\s*)(["'])([\s\S]*?)\2/gi, (match, attr, quote, href) => {
        const next = resolveMovedUrl(href);
        return next === href ? match : `${attr}${quote}${next}${quote}`;
      })
    : html;
